// extracted by mini-css-extract-plugin
export default {"popup":"TiVoTargetsSummary__popup-xbFW8","popupTrigger":"TiVoTargetsSummary__popupTrigger-ks_bq"};